// extracted by mini-css-extract-plugin
export var deliveryRow = "_rn-a";
export var fixedHeight = "_rn-4";
export var freightLogo = "_rn-9";
export var fullWidth = "_rn-3";
export var priceColumn = "_rn-5";
export var radioSelected = "_rn-7";
export var radioUnselected = "_rn-6";
export var selectedOption = "_rn-2";
export var selectedOptionContainer = "_rn-1";
export var selection = "_rn-0";
export var tallSkeletonText = "_rn-8";